<template>

  <b-modal v-model="isVisible" :size="size" hide-footer @hidden="closeModal" static>
    <slot>Contenido predeterminado</slot>
  </b-modal>
</template>

<script>
export default {
  name: "ModalContainer",

  props: {
    queryParam: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: "md"
    }
  },

  created() {
    this.getData();
  },

  data() {
    return {
      isVisible: false,
      queryValue: null
    };
  },

  methods: {
    getData() {
      if (!this.queryParam) {
        this.isVisible = false;
        return;
      }
      this.queryValue = this.$route.query[this.queryParam];

      if (this.queryValue) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    },

    closeModal() {
      this.isVisible = false;
    }
  },

  watch: {
    // Observar cambios en el query dinámico
    "$route.query": {
      deep: true,
      handler() {
        this.getData();
      }
    },

    // Si el modal se cierra, eliminar el query param de la URL
    isVisible(newValue) {
      if (!newValue) {
        const updatedQuery = { ...this.$route.query };
        delete updatedQuery[this.queryParam];
        this.$router.push({ path: this.$route.path, query: updatedQuery });
      }
    }
  },

};
</script>
